export default __webpack_public_path__ + "static/media/logo_academia_fester_no_margin.6b88a399.png";